<template>
  <SidePanel
    :isVisible="true"
    :leftCommand="true"
    :rightCommand="true"
    @save="onSave"
    @cancel="onCancel"
    :save="$t('create.dlgSaveDone')"
    :cancel="$t('general.cancel')"
    :header="header"
  >
    <div class="sidepanel-body">
      <div class="close-section">
        <label> {{ $t('close.title') }} </label>

        <div class="close-section-intro">
          {{ $t('close.headline') }}
          <ul>
            <li>{{ $t('close.line1') }}</li>
            <li>{{ $t('close.line2') }}</li>
          </ul>
        </div>

        <div class="close-control mt-3">
          <div @click="openPoll()" class="close-closed mt-2 pointer ">
            <font-awesome-icon
              v-if="!closedPoll"
              class="mr-1 ml-2 text-primary"
              :icon="['fas', 'dot-circle']"
            />
            <font-awesome-icon
              v-else
              class="mr-1 ml-2"
              :icon="['fal', 'circle']"
            />
            {{ $t('close.statusOpen') }}
          </div>

          <div @click="closePoll()" class="close-closed mt-2 pointer">
            <font-awesome-icon
              v-if="closedPoll"
              class="mr-1 ml-2 text-primary"
              :icon="['fas', 'dot-circle']"
            />
            <font-awesome-icon
              v-else
              class="mr-1 ml-2"
              :icon="['fal', 'circle']"
            />
            {{ $t('close.statusClosed') }}
          </div>
        </div>

        <div v-if="poll.type != 2" class="final-selection mx-2 mt-3">
          <div>{{ $t('close.selectionHeadline') }}</div>
          <div
            v-for="choice in choices"
            :key="choice.id"
            @click="toggleFinalChoice(choice)"
            class="close-poll-item d-flex border-top p-1 pointer"
          >
            <div class="item-selector mr-2">
              <font-awesome-icon
                v-if="choice.final"
                class="mr text-primary"
                :icon="['fas', 'check']"
              />
              <font-awesome-icon v-else class="mr" :icon="['fal', 'square']" />
            </div>
            <div class="item-text ml-1">
              <span v-if="poll.type == 1">
                {{ fullWeekDay(choice.start) }},
                {{ dayMonthYear(choice.start) }},
                <span v-if="choice.start">{{ choice.start | timeRange }}</span>
                <span v-else>-</span>
                <span v-if="choice.end">-{{ choice.end | timeRange }}</span
                >,
              </span>
              <div class="choice-text-survey">
                {{ choice.text | textComment }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import { pollMixin } from '@/components/mixins/PollMixins.js';
import { renderMixin } from '../mixins/RenderMixins';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'EditClose',
  mixins: [pollMixin, renderMixin],

  components: {
    SidePanel,
  },

  data() {
    return {
      localDetails: null,
      selected: -1,
      url: '',
      fileName: '',
      formData: new FormData(),
      isUploading: false,
      backupChoices: null,
      backupClosedPoll: null,
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

   
    header() {
      return this.$t('close.title');
    },
    cancelText() {
      return 'Zurück';
    },

    choices() {
      let choices = this.poll.choices;
      return choices;
    },

    closedPoll: {
      get() {
        return this.poll.closed;
      },
      set(value) {
        this.$store.commit('updateClosedPoll', value);
      },
    },
  },

  methods: {
    ...mapActions(['addImageInUserImages', 'replaceImagesToUserImagesObject']),

    closePoll() {
      this.closedPoll = true;
    },

    openPoll() {
      this.closedPoll = false;
    },

    toggleFinalChoice(choice) {
      // if (this.closedPoll) return;
      this.$store.commit('toggleFinalChoice', choice);
    },

    onCancel() {
      // save the current selected background
      console.log('Cancel the new configuration');
      this.closedPoll = this.backupClosedPoll;
      this.$store.commit('updateChoicesNoSort', this.backupChoices);
      this.$emit('cancel');
    },

    onSave() {
      // save the current selected background
      
      // save the project options
      // let options = this.poll.options;
      // this.$store.commit('updateOptions', options);

      let details = {
        title: this.poll.title,
        type: this.poll.type,
        description: this.poll.description,
        options: this.poll.options,
        ownerUser: this.ownerUser,
        bg_image_path: this.backgroundThumbnail,
        closed: this.poll.closed,
        design_id: this.poll.design_id,        
        deadline: this.poll.deadline
      };

      console.log('Save the new configuration', details);
      this.$store.dispatch('updateDetails', details).then(() => {
      });



      // save the choices
      this.$store.dispatch('updateChoicesNoSort', this.poll.choices);




      this.$emit('cancel');
    },
  },

  mounted() {
    this.backupClosedPoll = this.closedPoll;
    this.backupChoices = JSON.parse(JSON.stringify(this.poll.choices));
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

.close-section {
  & label {
    font-weight: $semi-bold-weight !important;
    margin-bottom: 0px;
  }
}

.close-section-intro {
  margin-top: 0.5rem;
}

.close-control {
  font-weight: $semi-bold-weight !important;
}

.item-selector {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  width: 40px;
  justify-content: center;
}

@media screen and (max-width: 480px) {
  .small-width {
    width: 180px;
    height: 120px;
  }
}
</style>
